import axiosInstance from "../../utility/axios";

// state

import {
  setCategories,
  createCategories,
  editCategory,
  deleteCategory,
  setBlogs,
  setBlog,
  createBlog,
  editBlog as updateBlog,
  setLoading,
  setComments,
  deleteBlog,
} from "../../store/slices/blog";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import { ISimpleData } from "../../store/types/misc";
import { ICreateBlog } from "../../store/types/blog";
import { toast } from "sonner";

export const get_categories = async (dispatch: AppDispatch) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.get("/v1/get-blog-categories");

    const { data } = response.data;
    dispatch(setCategories(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      console.log(message);
    }
  }
  dispatch(setLoading(false));
};

export const create_category = async (
  form: { name: string },
  dispatch: AppDispatch
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.post("/v1/create-blog-category", form);

    const { message, data } = response.data;

    dispatch(createCategories(data));
    toast.success(message, { description: "Category created successfully." });
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      toast.error(message);
    }
  }
  dispatch(setLoading(false));
};

export const edit_category = async (
  form: ISimpleData,
  dispatch: AppDispatch
) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.patch(
      `/v1/update-blog-category`,
      form
    );

    const { message, data } = response.data;
    dispatch(editCategory(data));
    toast.success(message, { description: "Category updated successfully." });
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      toast.error(message);
    }
  }
  dispatch(setLoading(false));
};

export const delete_category = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.delete(
      `/v1/delete-blog-category/${id}`
    );

    const { message, data } = response.data;
    dispatch(deleteCategory(data));
    toast.success(message, { description: "Category deleted successfully." });
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      toast.error(message);
    }
  }
  dispatch(setLoading(false));
};

/**
 *
 * @param dispatch
 */

export const get_blogs = async (dispatch: AppDispatch) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.get("/v1/get-blogs");

    const { data } = response.data;
    dispatch(setBlogs(data));
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      console.log(message);
    }
  }
  dispatch(setLoading(false));
};

export const get_blog = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.get(`/v1/get-blog/${id}`);

    const { data } = response.data;
    dispatch(setBlog(data));
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      console.log(message);
    }
  }
  dispatch(setLoading(false));
};

export const create_blog = async (form: ICreateBlog, dispatch: AppDispatch) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.post("/v1/create-blog", form);

    const { message, data } = response.data;
    dispatch(createBlog(data));
    toast.success(message, { description: "Blog created successfully." });
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      toast.error(message);
    }
  }
  dispatch(setLoading(false));
};

export const edit_blog = async (form: ICreateBlog, dispatch: AppDispatch) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.patch(`/v1/update-blog`, form);

    const { data, message } = response.data;
    dispatch(updateBlog(data));
    toast.success(message);
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      toast.error(message);
    }
  }
  dispatch(setLoading(false));
};

export const update_status = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading(true)); // Set loading to true at the start
  try {
    const response = await axiosInstance.patch(`/v1/blog-status/${id}`);
    if (response?.data) {
      const { message, data } = response.data;
      dispatch(updateBlog(data));
      toast.success(message, { description: "Status updated successfully." });
    } else {
      throw new Error("No response data");
    }
  } catch (err: any) {
    let errorMessage = "Something went wrong";
    if (isAxiosError(err) && err?.response?.data?.message) {
      errorMessage = err.response.data.message;
    }
    toast.error(errorMessage);
  }
  dispatch(setLoading(false));
};

export const destroy_blog = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading(false));
  try {
    const response = await axiosInstance.delete(`/v1/delete-blog/${id}`);

    const { message, data } = response.data;
    dispatch(deleteBlog(data));
    toast.success(message, { description: "Blog deleted successfully." });
  } catch (err: any) {
    if (isAxiosError(err)) {
      const message = err?.response?.data?.message ?? "Something went wrong";
      toast.error(message);
    }
  }
  dispatch(setLoading(false));
};

/**
 * Comments
 */
export const get_comments = async (dispatch: AppDispatch, id: string) => {
  try {
    const response = await axiosInstance.get(`/v1/get-blog-comments/${id}`);

    const { data } = response.data;
    dispatch(setComments(data));
  } catch (error: any) {
    if (isAxiosError(error)) {
      const message = error?.response?.data?.message ?? "Something went wrong";
      console.log(message);
    }
  }
};
